import { createContext, useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { useDispatch, useSelector } from "react-redux";
import { getName } from "country-list";
import { Skeleton } from "primereact/skeleton";

import EntitySettingsSideBar from "../siderbar/EntitySettingsSideBar";
import "../entities.scss";
import Layout from "../../../Layout";

import { fetchGeneralInformation } from "../general-information/generalInformationSlice";
const EntityContext = createContext();

const EntitySettings = () => {
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();

  const activeTab =
    location.pathname.split("/entities")[4] || "active-services";

  const [entity, setEntity] = useState({});
  const [loading, setLoading] = useState(true);

  const generalInformation = useSelector(
    (state) => state.generalInformation.generalInformation,
  );
  const generalInformationStatus = useSelector(
    (state) => state.generalInformation.status,
  );

  const fetchEntityDetails = async () => {
    dispatch(fetchGeneralInformation(id));
  };

  useEffect(() => {
    if (generalInformationStatus === "succeeded") {
      setLoading(false);
    } else if (generalInformationStatus === "loading") {
      setLoading(true);
    }
  }, [generalInformationStatus]);

  useEffect(() => {
    fetchEntityDetails(id);
  }, [id]);

  useEffect(() => {
    if (generalInformation?.data) {
      setEntity(generalInformation?.data);
    }
  }, [generalInformation]);

  return (
    <EntityContext.Provider value={{ loading, entity }}>
      <Layout
        title={"Entity Settings"}
        subtitle={
          "Manage key configuration and services for your selected entity"
        }
        crumbs={[
          { label: "My Entities", url: "/entities" },
          {
            label: (
              <div className="flex">
                {!loading ? (
                  entity?.name
                ) : (
                  <Skeleton width="100px" height="20px" className="mr-1" />
                )}
                {!loading ? (
                  " "
                ) : (
                  <Skeleton width="10px" height="20px" className="mr-1" />
                )}
                {!loading ? (
                  <>
                    (
                    <ReactCountryFlag
                      countryCode={entity?.country || ""}
                      svg
                      className=""
                    />{" "}
                    {getName(entity?.country || "")})
                  </>
                ) : (
                  <Skeleton width="150px" height="20px" className="mr-1" />
                )}
              </div>
            ),
            id: "entity",
            url: `/entity/${id}/dashboard`,
          },
          { label: "Entity Settings", id: "entity-settings" },
        ]}
      >
        <div className="grid grid-nogutter">
          <div className="col-12 Entities-container">
            <div className="grid">
              <div className="col-3">
                <EntitySettingsSideBar activeTab={activeTab} />
              </div>
              <div className="col-9">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </EntityContext.Provider>
  );
};
export default EntitySettings;
